<template>
    <div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Имя <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="fullname">
            <div class="form-alert-danger" v-show="showAlert === 'fullname'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                E-mail <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="email">
            <div class="form-alert-danger" v-show="showAlert === 'email'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Контактный телефон
            </div>
            <input type="text" class="cd-modal-text-input" v-model="phone"
                   v-mask="'+# (###) ### ## ##'" v-on:focus="addCountryCode">
            <div class="form-alert-danger" v-show="showAlert === 'phone'">
                Обязательное поле!
            </div>
        </div>

        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Организация
            </div>
            <JHCustomSelect v-model="inputOrganizationName"
                            :selectOptions="optionsOrganizations"
                            :selectName="(organization, key) => organization.name"
                            :selectableParamCondition="(organization, key) => organization.id"
                            :selectedParamValue="selectedParamValueOrganization"
                            @selected="selectOrganization"
                            :visibleMessageLoading="waitingResponseToOrganizationRequest"
            />
<!--            <v-select class="ap-select-field" :options="optionsOrganizations" :reduce="organization => organization.id"-->
<!--                      label="name" v-model="organizationID"></v-select>-->
            <div class="form-alert-danger" v-show="showAlert === 'organization'">
                Обязательное поле!
            </div>
        </div>

        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Роль <span class="red-text">*</span>
            </div>
            <select class="cd-modal-text-input" v-model="role" v-bind:disabled="checkPermissions">
                <option value="admin">Специалист</option>
                <option value="superadmin">Администратор</option>
            </select>
            <div class="form-alert-danger" v-show="showAlert === 'role'">
                Обязательное поле!
            </div>
        </div>
        <div class="modal-button" v-on:click="submitAdd">
            {{buttonName}}
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import JHCustomSelect from "../../../TemplatesLibrary/JHCustomSelect";

export default {
    name: "DataEntryFields",
    components: {
      JHCustomSelect,
        vSelect
    },
    data() {
        return {
            fullname: '',
            email: '',
            phone: '',
            role: '',
        }
    },
    props: {
        buttonName: {
            type: String
        },
        userData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        showAlert: {
            type: String
        }
    },
    methods: {
        addCountryCode() {
            if (this.phone === '') {
                this.phone = 7
            }
        },
        selectOrganization(selectedParam) {
            this.$store.commit('adminPanel/selectUser/organizations/MASK', '');
            this.selectedParamValueOrganization = selectedParam;
        },
        submitAdd() {
            this.$emit('apply', {
                fullname: this.fullname,
                email: this.email,
                phone: this.phone,
                role: this.role,
                organization_id : this.selectedParamValueOrganization
            });
        }
    },
    computed: {
        inputOrganizationName: {
            get() {
                return this.$store.state.adminPanel.selectUser.organizations.mask;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/organizations/MASK', value);
            }
        },
        selectedParamValueOrganization: {
            get() {
                return this.$store.state.adminPanel.selectUser.selectedOrganizationID;
            },
            set(value) {
                this.$store.commit('adminPanel/selectUser/SELECTED_ORGANIZATION_ID', value);
            }
        },
        checkPermissions() {
            return this.$store.state.profile.userRole !== 'superadmin'
        },
        optionsOrganizations() {
            return this.$store.getters["adminPanel/selectUser/ORGANIZATIONS_T"];
        },
        waitingResponseToOrganizationRequest() {
            return this.$store.state.adminPanel.selectUser.organizations.waitingResponseToOrganizationRequest;
        },
    },
    async mounted() {
        await this.$store.dispatch('adminPanel/selectUser/organizations/GET_ORGANIZATIONS');
        if (Object.keys(this.userData).length > 0) {
            this.fullname = this.userData.fullname;
            this.email = this.userData.email;
            this.phone = this.userData.phone;
            this.role = this.userData.role;
            this.selectedParamValueOrganization = this.userData.organization_id;
        }
    },
    destroyed() {
        this.$store.commit('adminPanel/organizations/CLEAR_ORGANIZATIONS');
    }
}
</script>

<style scoped>
    /*.grey-select {*/
    /*    color: #767676;*/
    /*}*/

</style>
